import * as C from './constants';
import { IPlayerState } from './reducer.types';
import { showApiRequestInitReducer } from './reducers/showApiRequestInitReducer';
import { showApiRequestSuccessReducer } from './reducers/showApiRequestSuccessReducer';
import { showApiRequestFailureReducer } from './reducers/showApiRequestFailureReducer';
import { trackApiRequestSuccessReducer } from './reducers/trackApiRequestSuccessReducer';
import { setPlayStatusReducer } from './reducers/setPlayStatusReducer';
import { setCurrentlyPlayingTrackIdReducer } from './reducers/setCurrentlyPlayingTrackIdReducer';
import { trackProgressReducer } from './reducers/trackProgressReducer';
import { seekingReducer } from './reducers/seekingReducer';
import { trackEndReducer } from './reducers/trackEndReducer';
import trackDurationReducer from './reducers/trackDurationReducer';
import * as A from './actions';

export const initialState: IPlayerState = {
  // Show api call state
  isShowApiRequestPending: false,
  showApiRequestErrorMessage: '',

  // Track api call state
  isTrackApiRequestPending: false,
  trackApiRequestError: null,

  // ShowId extracted either from query params, or fetched via trackApi request
  showId: null,

  // payload of showApiRequestSuccess() action
  showActionPayload: null,

  tracksById: null,
  // Playlist of trackIds
  tracksIdsOrdered: null,

  currentlyPlayingTrackDuration: 0,
  currentlyPlayingTrackId: null,
  playStatus: C.STOPED,
  // 1 durationPlayedInPermille => 1/1000 of track duration was played
  durationPlayedInPermille: 0,
  durationPlayedInSeconds: 0,
  isSeeking: false,
};

export default (state = initialState, action: A.IPlayerAction): IPlayerState => {
  switch (action.type) {
    case C.SHOW_API_REQUEST_INIT: {
      return showApiRequestInitReducer(state);
    }

    case C.SHOW_API_REQUEST_SUCCESS: {
      return showApiRequestSuccessReducer(
        state,
        action as ReturnType<typeof A.showApiRequestSuccess>,
      );
    }

    case C.SHOW_API_REQUEST_FAILURE: {
      return showApiRequestFailureReducer(
        state,
        action as ReturnType<typeof A.showApiRequestFailure>,
      );
    }

    case C.TRACK_API_REQUEST_INIT: {
      return {
        ...state,
        isTrackApiRequestPending: true,
        trackApiRequestError: null,
      };
    }

    case C.TRACK_API_REQUEST_SUCCESS: {
      return trackApiRequestSuccessReducer(
        state,
        action as ReturnType<typeof A.trackApiRequestSuccess>,
      );
    }

    case C.TRACK_API_REQUEST_FAILURE: {
      return {
        ...state,
        isTrackApiRequestPending: false,
        // trackApiRequestError: action.payload.error,
      };
    }

    case C.SET_PLAY_STATUS: {
      return setPlayStatusReducer(state, action as ReturnType<typeof A.setPlayStatus>);
    }

    case C.SET_CURRENTLY_PLAYING_TRACK_ID: {
      return setCurrentlyPlayingTrackIdReducer(
        state,
        action as ReturnType<typeof A.setCurrentlyPlayingTrackId>,
      );
    }

    case C.TRACK_PROGRESS: {
      return trackProgressReducer(state, action as ReturnType<typeof A.trackProgress>);
    }

    case C.TRACK_DURATION: {
      return trackDurationReducer(state, action as ReturnType<typeof A.trackDuration>);
    }

    case C.TRACK_END: {
      return trackEndReducer(state);
    }

    case C.SEEKING: {
      return seekingReducer(state, action as ReturnType<typeof A.seeking>);
    }

    case C.SHOW_ID: {
      return {
        ...state,
        showId: (action as ReturnType<typeof A.showId>).payload.showId,
      };
    }

    case C.TOGGLE_PLAY_STATUS: {
      return {
        ...state,
        playStatus: state.playStatus === C.PLAYING ? C.PAUSED : C.PLAYING,
      };
    }

    default: {
      return state;
    }
  }
};
